import React from 'react';
import { EquipmentCardData } from '../../hooks/useAgentConversation';

interface EquipmentCardProps {
  card: EquipmentCardData;
  onAskAbout?: (title: string, stockNumber: string) => void;
}

const EquipmentCard: React.FC<EquipmentCardProps> = ({ card, onAskAbout }) => {
  const { data } = card;

  const formatPrice = (price: number | null): string => {
    if (price === null || price === undefined) return 'Contact for pricing';
    return `$${price.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
  };

  const formatHours = (hours: number | null): string => {
    if (!hours || hours === 0) return '';
    return `${Number(hours).toLocaleString()} hrs`;
  };

  const isNew = (data.equipment_type || '').toUpperCase() === 'NEW';
  const hours = formatHours(data.unit_hours);

  return (
    <div className="equipment-card">
      <div className="equipment-card__header">
        <span className="equipment-card__title">{card.title}</span>
        <span className={`equipment-card__type-badge equipment-card__type-badge--${isNew ? 'new' : 'used'}`}>
          {isNew ? 'New' : 'Used'}
        </span>
      </div>

      <div className="equipment-card__details">
        <div className="equipment-card__price">{formatPrice(data.price)}</div>

        <div className="equipment-card__meta">
          {data.status && (
            <span className="equipment-card__status">
              {data.status === 'INVENTORY' ? 'Available' : data.status === 'ON_ORDER' ? 'On Order' : data.status}
            </span>
          )}
          {hours && <span className="equipment-card__hours">{hours}</span>}
          {(data.location_name || data.location) && (
            <span className="equipment-card__location">{data.location_name || data.location}</span>
          )}
        </div>

        {data.description && (
          <p className="equipment-card__description">
            {data.description.length > 120 ? `${data.description.slice(0, 120)}...` : data.description}
          </p>
        )}

        {data.options && data.options.length > 0 && (
          <div className="equipment-card__options">
            {data.options.slice(0, 3).map((opt, i) => (
              <span key={i} className="equipment-card__option-tag">{opt}</span>
            ))}
            {data.options.length > 3 && (
              <span className="equipment-card__option-more">+{data.options.length - 3} more</span>
            )}
          </div>
        )}
      </div>

      {card.stale_warning && (
        <div className="equipment-card__stale-warning">
          Availability may have changed — please confirm with us.
        </div>
      )}

      {onAskAbout && (
        <button
          className="equipment-card__cta"
          onClick={() => onAskAbout(card.title, data.stock_number)}
        >
          Ask about this machine
        </button>
      )}
    </div>
  );
};

export default EquipmentCard;
